
import { useEffect, useState, useCallback } from "react";
import { getNotifications } from '../../services/apiService';

export default function NotificationsModal({ show, onClose, userId }) {
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [nextPageId, setNextPageId] = useState(null);

  const loadNotifications = useCallback(async (pageId) => {
    if (!userId) return;

    setLoading(true);
    try {
      const response = await getNotifications(userId, pageId);
      setNotifications(prev => [...prev, ...response.data.notifications]);
      setNextPageId(response.data.nextPageId);
    } catch (e) {
      console.error("Error loading notifications:", e);
      setError("Failed to load notifications.");
    }
    setLoading(false);
  }, [userId]);

  useEffect(() => {
    if (show) {
      // Reset state when modal is opened
      setNotifications([]);
      setNextPageId(null);
      setError(null);
      loadNotifications(undefined);
    }
  }, [show, userId, loadNotifications]);


  const handleLoadMore = () => {
    if (nextPageId) {
      loadNotifications(nextPageId);
    }
  };

  if (!show) return null;

  return (
    <div
      className="modal show fade d-block"
      tabIndex="-1"
      style={{ backgroundColor: "rgba(0,0,0,0.35)" }}
      onClick={onClose}
    >
      <div
        className="modal-dialog modal-lg modal-dialog-centered"
        onClick={e => e.stopPropagation()}
      >
        <div
          className="modal-content"
          style={{
            background: '#ffffff',
            color: '#0f172a',
            border: '1px solid #e5e7eb',
            boxShadow: '0 20px 50px rgba(15, 23, 42, 0.08)',
          }}
        >
          <div
            className="modal-header"
            style={{
              borderBottom: '1px solid #e5e7eb',
              background: '#ffffff',
            }}
          >
            <h5 className="modal-title">Notifications for User ID: {userId}</h5>
            <button type="button" className="btn-close" onClick={onClose} />
          </div>
          <div className="modal-body" style={{ maxHeight: '60vh', overflowY: 'auto' }}>
            {error && <div className="alert alert-danger">{error}</div>}
            {notifications.length > 0 ? (
              <ul className="list-group">
                {notifications.map((n) => (
                  <li
                    key={n.id}
                    className={`list-group-item ${n.read ? '' : 'fw-bold'}`}
                    style={{
                      background: '#ffffff',
                      color: '#0f172a',
                      borderColor: '#e5e7eb',
                    }}
                  >
                    <div className="d-flex justify-content-between">
                      <h6 className="mb-1">{n.title}</h6>
                      <small>{new Date(n.dateTime).toLocaleString()}</small>
                    </div>
                    <p className="mb-1">{n.body}</p>
                    <small>Transaction ID: {n.transactionId}</small>
                  </li>
                ))}
              </ul>
            ) : (
              !loading && <p className="text-muted mb-0">No notifications available.</p>
            )}
            {loading && <div className="text-center"><div className="spinner-border" role="status"><span className="visually-hidden">Loading...</span></div></div>}
          </div>
          <div
            className="modal-footer"
            style={{
              borderTop: '1px solid #e5e7eb',
              background: '#ffffff',
            }}
          >
            {nextPageId && !loading && (
              <button
                type="button"
                className="btn btn-primary"
                onClick={handleLoadMore}
                style={{
                  background: 'linear-gradient(135deg, #2563eb, #22c55e)',
                  border: 'none',
                  fontWeight: 700,
                  color: '#0b1220',
                }}
              >
                Load More
              </button>
            )}
            <button
              type="button"
              className="btn btn-secondary"
              onClick={onClose}
              style={{
                background: '#f8fafc',
                color: '#0f172a',
                border: '1px solid #e5e7eb',
              }}
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
